import React, { createContext, useEffect, useState } from "react";
import i18next from "i18next";
import "./i18n";
import "./App.scss";
import Utils from "./utils/Utils";
import Viewport from "./components/ViewPort/ViewPort";
import { useTranslation } from "react-i18next";
import { AUTHORIZATION_DATA, GAME_TIMES_DATA } from "./services/RequestDatas";
import RequestManager from "./services/RequestManager";

export const Context = createContext({});

function App() {
  const params = Utils.getURLParams();
  const partnerID = params["partnerID"] || "999";
  const gameID = Number(params["gameID"]) || 8;

  const [gameMode, setGameMode] = useState(
    parseInt(gameID) === 8 ? Utils.STW_CLASSIC : Utils.STW_DELUXE
  );
  const [applicationReady, setApplicationReady] = useState(false);
  const [language, setLanguage] = useState(params["lang"] || "en");
  const [gamesData, setGamesData] = useState();
  const [lastNumber, setLastNumber] = useState("");
  const [lastSuit, setLastSuit] = useState("");

  const socket = RequestManager.getInstance().webSocket;

  const store = {
    gameMode: { get: gameMode, set: setGameMode },
    applicationReady: { get: applicationReady, set: setApplicationReady },
    language: { get: language, set: setLanguage },
    gamesData: { get: gamesData, set: setGamesData },
    lastResultNumber: { get: lastNumber, set: setLastNumber },
    lastResultSuit: { get: lastSuit, set: setLastSuit },
    gameID,
  };

  useEffect(() => {
    initAuthorization();
    changeAppLanguage(language);
    console.log(">> STW beta v0.2");

    socket.addEventListener(
      RequestManager.AUTO_GAME_TIMES_DATA,
      parseGameDataUpdate
    );

    return () => {
      socket.removeEventListener(
        RequestManager.AUTO_GAME_TIMES_DATA,
        parseGameDataUpdate
      );
    };
  }, [applicationReady]);

  const changeAppLanguage = lang => {
    i18next.changeLanguage(lang, error => error ? console.log("i18n error: ", error) : null).then();
  };

  const initAuthorization = () => {
    socket.onopen = () => {
      AUTHORIZATION_DATA.params.language = language;
      AUTHORIZATION_DATA.params.site_id = partnerID;

      socket.send(JSON.stringify(AUTHORIZATION_DATA));
      socket.addEventListener(RequestManager.AUTHORIZATION_EVENT, handleAuthorization, { once: true });
      socket.addEventListener(RequestManager.SOCKET_CLOSED_EVENT, handleSocketClosing, { once: true });
    };
  };

  const handleAuthorization = ({ detail }) => {
    const authorizationSucceeded = detail && detail["data"];

    if (authorizationSucceeded) {
      setApplicationReady(true);
      initGameTimesRequest();
    }
  };

  const initGameTimesRequest = () => {
    GAME_TIMES_DATA.params.where.sport.id["@in"] = [gameID];
    socket.send(JSON.stringify(GAME_TIMES_DATA));
    socket.addEventListener(
      RequestManager.GAME_TIMES_EVENT,
      parseGameTimesData,
      { once: true }
    );
  };

  const parseGameTimesData = ({ detail }) => {
    let gameData = detail?.data?.data?.sport;

    gameData = gameData ? gameData[Utils.firstKey(gameData)]?.region : {};
    gameData = gameData ? gameData[Utils.firstKey(gameData)]?.game : {};

    setGamesData(gameData);
  };

  const parseGameDataUpdate = ({ detail }) => {
    console.log(detail);
    let updatedGamesData = detail?.sport[gameID]?.region;
    updatedGamesData = updatedGamesData[Utils.firstKey(updatedGamesData)]?.game;

    setGamesData(updatedGamesData);
  };

  const handleSocketClosing = () => {
    setApplicationReady(false);
  };

  return applicationReady ? (
    <Context.Provider value={store}>
      <div className="app">
        <Viewport />
      </div>
    </Context.Provider>
  ) : (
    <div className="app-loader" />
  );
}

export default App;
